import {useTranslation} from 'react-i18next';

import {Box, Step, StepLabel, Stepper, Typography} from '@mui/material';

import {GUIDED_WIZARD_STEP_ORDER, type WorkforceProfileGuidedStepId} from '../../types/workforceProfileWizardTypes';

const STEP_ICON_SIZE = 24;
const STEP_MIN_WIDTH = 44;

export interface Props {
  activeStepId: WorkforceProfileGuidedStepId;
}

export const WorkforceProfileWizardStepper = ({activeStepId}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage.wizard.steps'});
  const activeIndex = GUIDED_WIZARD_STEP_ORDER.indexOf(activeStepId);
  const stepCount = GUIDED_WIZARD_STEP_ORDER.length;

  const stepperSx = {
    minWidth: stepCount * STEP_MIN_WIDTH,
    py: 0.5,
    '& .MuiStep-root': {
      px: 0,
    },
    '& .MuiStepConnector-root': {
      top: STEP_ICON_SIZE / 2,
      left: `calc(-50% + ${STEP_ICON_SIZE / 2}px)`,
      right: `calc(50% + ${STEP_ICON_SIZE / 2}px)`,
    },
    '& .MuiStepConnector-line': {
      borderTopWidth: 2,
    },
    '& .MuiStepIcon-root': {
      width: STEP_ICON_SIZE,
      height: STEP_ICON_SIZE,
      fontSize: '0.75rem',
    },
    '& .MuiStepLabel-label': {
      display: 'none',
    },
  };

  return (
    <Box sx={{mb: 2}}>
      <Typography variant='body2' color='text.secondary' sx={{textAlign: 'center', mb: 0.5}}>
        {t('stepProgress', {current: activeIndex + 1, total: stepCount})}
      </Typography>
      <Typography variant='subtitle2' sx={{textAlign: 'center', mb: 1.5}}>
        {t(activeStepId)}
      </Typography>
      <Box sx={{overflowX: 'auto', mx: -1, px: 1}}>
        <Stepper activeStep={activeIndex} sx={stepperSx}>
          {GUIDED_WIZARD_STEP_ORDER.map((stepId) => (
            <Step key={stepId}>
              <StepLabel />
            </Step>
          ))}
        </Stepper>
      </Box>
    </Box>
  );
};
